<template>
  <vs-card>
    <div slot="header">
      Domicilios
    </div>
    <vs-table :data="addresses">
      <template slot="thead">
        <vs-th>Fecha Residencia</vs-th>
        <vs-th>Fecha Registro</vs-th>
        <vs-th>Telefono</vs-th>
        <vs-th>Dirección</vs-th>
        <vs-th>Colonia/Población</vs-th>
        <vs-th>Delegación/Municipio</vs-th>
        <vs-th>Ciudad</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th>CP</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(address, index) in data" :key="index">
          <vs-td>{{address.fechaResidencia}}</vs-td>
          <vs-td>{{address.fechaRegistroDomicilio}}</vs-td>
          <vs-td>{{address.numeroTelefono}}</vs-td>
          <vs-td>{{address.direccion}}</vs-td>
          <vs-td>{{address.coloniaPoblacion}}</vs-td>
          <vs-td>{{address.delegacionMunicipio}}</vs-td>
          <vs-td>{{address.ciudad}}</vs-td>
          <vs-td>{{address.estado}}</vs-td>
          <vs-td>{{address.CP}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-card>
</template>

<script>
export default {
  name: "ci-addresses-table",
  props: ["addresses"]
}
</script>

<style scoped>

</style>
